import { StatusBadge } from '@/components/ui';

/** QA-593 — 쇼핑몰 노출 중일 때만 [노출] 배지(숨김이면 표시 없음). */
export const ArtistDisplayedBadge = ({ displayed }: { displayed: boolean | undefined }) =>
  displayed === true ? <StatusBadge variant="info" size="sm" label="노출" data-testid="artist-displayed-badge" /> : null;
